<div class="add-organization-page">
  <div class="card">
    <div class="page-header">
      <div class="header-left">
        <a
          routerLink="/administration"
          class="nav-link"
          [attr.title]="'administration.addOrganization.backToAdministration' | translate"
          [attr.aria-label]="'administration.addOrganization.backToAdministration' | translate"
        >
          <lucide-angular name="arrow-left" [size]="18" class="card-icon card-icon-gray"></lucide-angular>
        </a>

        <div class="page-header-text">
          <h2 class="page-title">
            {{ "administration.addOrganization.title" | translate }}
          </h2>
        </div>
      </div>
    </div>
  </div>

  <!-- SUCCESS STATE -->
  <div class="success-card" *ngIf="isSuccess" #successCard>
    <div class="success-icon">
      <lucide-angular name="check" [size]="20"></lucide-angular>
    </div>

    <div class="success-content">
      <p class="success-title">
        {{ "administration.addOrganization.success.title" | translate: { name: successOrganizationName } }}
      </p>

      <p class="success-message">
        {{ "administration.addOrganization.success.message" | translate }}
      </p>
    </div>
  </div>

  <!-- FORM -->
  <form [formGroup]="organizationForm" (ngSubmit)="submit()" class="organization-form">
    <!-- ORGANIZATION -->
    <section class="card" formGroupName="organization">
      <div class="card-header">
        <div class="card-header-left">
          <lucide-angular name="building-2" [size]="20" class="card-icon card-icon-blue"></lucide-angular>
          <h3 class="header-title">
            {{ "administration.organization.title" | translate }}
          </h3>
        </div>
      </div>
      <div class="card-content">
        <div class="two-field-row">
          <!-- Name -->
          <div class="field">
            <label class="label" for="name"> {{ "administration.organization.name" | translate }} </label>
            <input
              id="name"
              autocomplete="organization"
              class="form-input"
              type="text"
              formControlName="name"
              (input)="organizationNameAlreadyUsed = false"
            />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.name.touched &&
                organizationForm.controls.organization.controls.name.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>

            <div class="error-message" *ngIf="organizationNameAlreadyUsed">
              <span>
                {{ "administration.addOrganization.organizationNameAlreadyUsed" | translate }}
              </span>
            </div>
          </div>

          <!-- Address -->
          <div class="field">
            <label class="label" for="address">
              {{ "administration.organization.address" | translate }}
            </label>

            <input id="address" autocomplete="address-line1" class="form-input" type="text" formControlName="address" />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.address.touched &&
                organizationForm.controls.organization.controls.address.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>
        </div>

        <div class="two-field-row">
          <!-- Address number -->
          <div class="field">
            <label class="label" for="addressNb">
              {{ "administration.organization.addressNb" | translate }}
            </label>

            <input id="addressNb" class="form-input" type="text" formControlName="addressNb" />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.addressNb.touched &&
                organizationForm.controls.organization.controls.addressNb.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>

          <!-- Postal code -->
          <div class="field">
            <label class="label" for="postalCode">
              {{ "administration.organization.postalCode" | translate }}
            </label>

            <input id="postalCode" autocomplete="postal-code" class="form-input" type="text" formControlName="postalCode" />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.postalCode.touched &&
                organizationForm.controls.organization.controls.postalCode.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>
        </div>

        <div class="two-field-row">
          <!-- Location -->
          <div class="field">
            <label class="label" for="location">
              {{ "administration.organization.location" | translate }}
            </label>

            <input id="location" autocomplete="address-level2" class="form-input" type="text" formControlName="location" />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.location.touched &&
                organizationForm.controls.organization.controls.location.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>

          <!-- Country -->
          <div class="field">
            <label class="label" for="country">
              {{ "administration.organization.country" | translate }}
            </label>

            <input id="country" autocomplete="country-name" class="form-input" type="text" formControlName="country" />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.organization.controls.country.touched &&
                organizationForm.controls.organization.controls.country.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ADMIN -->
    <section class="card" formGroupName="admin">
      <div class="card-header">
        <div class="card-header-left">
          <lucide-angular name="user" [size]="20" class="card-icon card-icon-green"></lucide-angular>
          <h3 class="header-title">
            {{ "administration.admin.title" | translate }}
          </h3>
        </div>
      </div>
      <div class="card-content">
        <div class="two-field-row">
          <div class="field">
            <label class="label" for="email"> {{ "administration.admin.email" | translate }} </label>
            <input
              id="email"
              autocomplete="email"
              class="form-input"
              type="email"
              formControlName="email"
              (input)="emailAlreadyUsed = false"
            />

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.admin.controls.email.touched &&
                organizationForm.controls.admin.controls.email.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.admin.controls.email.touched && organizationForm.controls.admin.controls.email.errors?.['pattern']
              "
            >
              <span>{{ "administration.emailInvalid" | translate }}</span>
            </div>

            <div class="error-message" *ngIf="emailAlreadyUsed">
              <span>
                {{ "administration.addOrganization.emailAlreadyUsed" | translate }}
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label" for="language">
              {{ "administration.organization.language" | translate }}
            </label>

            <select id="language" class="form-input" formControlName="lang">
              <option *ngFor="let language of languages" [value]="language">
                {{ language | uppercase }}
              </option>
            </select>

            <div
              class="error-message"
              *ngIf="
                organizationForm.controls.admin.controls.lang.touched && organizationForm.controls.admin.controls.lang.errors?.['required']
              "
            >
              <span>{{ "common.required" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ACTIONS -->
    <div class="form-actions">
      <button class="button-blue" type="submit" [disabled]="organizationForm.disabled">
        <lucide-angular name="plus" [size]="18"></lucide-angular>

        {{ "administration.addOrganization.submit" | translate }}
      </button>
    </div>
  </form>
</div>
